<template>
  <form @submit.prevent="submit">
    <Stack>
      <Alert
        type="info"
        title="Check your email inbox"
        description="It looks like your account hasn't been activated yet. We've sent a verification code to your email address. Please check your inbox and enter the code below, along with your desired password."
      />
      <Stack space="xsmall">
        <FormTextInput
          :value="form.email"
          label="Email address"
          name="email"
          type="email"
          autocomplete="username"
          @update:modelValue="updateFormValue"
          :error="form.errors.email"
        />
        <FormTextInput
          :value="form.verification_code"
          label="Verification code"
          name="verification_code"
          helperText="Check your email inbox for the verification code."
          @update:modelValue="updateFormValue"
          :error="form.errors.verification_code"
        />
        <FormTextInput
          :value="form.password"
          label="New password"
          name="password"
          type="password"
          autocomplete="current-password"
          @update:modelValue="updateFormValue"
          :error="form.errors.password"
        />
        <FormTextInput
          :value="form.password_confirmation"
          label="Confirm new password"
          name="password_confirmation"
          type="password"
          @update:modelValue="updateFormValue"
          :error="form.errors.password_confirmation"
        />
      </Stack>
      <Stack align="right">
        <Button
          :isLoading="form.processing"
          type="submit"
          text="Sign in to your account"
          @click="submit"
        />
      </Stack>
    </Stack>
  </form>
</template>

<script setup>
import { router } from '@inertiajs/vue3'
import { Button, FormTextInput, Stack } from '@aryeo/runway'

import Alert from '@/Runway/Alerts/Simple.vue'

const props = defineProps({
  email: {
    type: String,
    default: null,
  },
  loginViaVerificationCodeUrl: {
    type: String,
    required: true,
  },
})

const form = router.form({
  email: props.email,
  verification_code: null,
  password: null,
  password_confirmation: null,
})

const updateFormValue = ({ key, value }) => {
  let newValue = value

  if (key === 'email') {
    newValue = newValue.toLowerCase()
  }

  form[key] = newValue
}

const submit = () => {
  form.post(props.loginViaVerificationCodeUrl)
}
</script>
